import { ImportExecutionDetailView } from '@today/ui-domain'
import { useNavigate, useParams } from 'react-router-dom'
import { useImportExecutionDetail } from '@/hooks/imports/useImportExecutionDetail'

/** `/t/:slug/admin/imports/:executionId` — one import's drill-down (TO-399 REQ-010). */
export function ImportDetailPage() {
	const navigate = useNavigate()
	const { executionId = '' } = useParams()
	const detail = useImportExecutionDetail(executionId, () => void navigate('..', { relative: 'path' }))
	return (
		<div className="flex flex-col gap-6 p-6">
			<ImportExecutionDetailView {...detail} />
		</div>
	)
}
